import React, { useContext } from 'react';
import CardContext from '../../../../contexts/CardContext';
import FlexCentered from '../../../Common/FlexCentered';
import { CardSkeleton } from '../../../Skeleton';
import ScalingNumber from '../../../ScalingNumber';

const CardContent = ({
  isLoading,
  number,
  metricId,
}: {
  isLoading: boolean;
  number: number;
  metricId: string;
}) => {
  const { h } = useContext(CardContext);

  return (
    <FlexCentered
      style={{
        height: '100%',
        width: '100%',
        fontSize: h === 1 ? '0.8em' : '2em',
        lineHeight: h === 1 ? '1.3em' : '2.2em',
        alignItems: 'flex-start',
      }}
    >
      {isLoading && <CardSkeleton />}
      {!isLoading && <ScalingNumber number={number} metricId={metricId} />}
    </FlexCentered>
  );
};

export default CardContent;
